// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('h2')`
  border-top: 1px solid ${props => props.theme.pdbConfig.borderColor};
  color: ${props => props.theme.pdbConfig.headingColor};
  font-size: ${props => props.theme.pdbConfig.fontSize};
  padding: 3.5rem .5rem;

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;
